module.exports = __webpack_public_path__ + "img/selected1-min.135be21a.png";